import { Failure, Success } from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

import {
	getDefaultNetworkStatus,
	getNetworkStatusStarted,
	getNetworkStatusDone,
	getNetworkStatusFailed,
} from '@utils';

import {
	IDmcaActionAddFilesPayload,
	IDmcaActionRemoveFilePayload,
	IDmcaActionSubmitPayload,
	IDmcaActionSubmitErrorPayload,
	IDmcaActionUploadFilePayload,
	IDmcaActionUploadFileDonePayload,
	IDmcaActionUploadFileErrorPayload,
	addFiles,
	removeFile,
	submitDmca,
	uploadFile,
} from '@redux/actions';

import { IDmcaStore } from '@interfaces';

export const getDmcaInitialState = (): IDmcaStore => ({
	files: {},
	form: {
		meta: getDefaultNetworkStatus(),
	},
});

export const dmca = reducerWithInitialState<IDmcaStore>(getDmcaInitialState())

	// UPLOAD FILE
	.case(uploadFile.async.started, (state: IDmcaStore, payload: IDmcaActionUploadFilePayload) => {
		return {
			...state,
			files: {
				...state.files,
				[payload.file.uploadId]: {
					data: payload.file,
					meta: getNetworkStatusStarted(),
				},
			},
		};
	})
	.case(uploadFile.async.done, (state: IDmcaStore, payload: Success<IDmcaActionUploadFilePayload, IDmcaActionUploadFileDonePayload>) => {
		return {
			...state,
			files: {
				...state.files,
				[payload.params.file.uploadId]: {
					data: {
						...payload.params.file,
						...payload.result,
					},
					meta: getNetworkStatusDone(),
				},
			},
		};
	})
	.case(uploadFile.async.failed, (state: IDmcaStore, payload: Failure<IDmcaActionUploadFilePayload, IDmcaActionUploadFileErrorPayload>) => {
		return {
			...state,
			uploads: {
				...state.files,
				[payload.params.file.uploadId]: {
					data: null,
					meta: getNetworkStatusFailed(payload.error),
				},
			},
		};
	})

	// ADD FILE
	.case(addFiles, (state: IDmcaStore, payload: IDmcaActionAddFilesPayload) => {
		const newState = { ...state };

		payload.files.forEach((file) =>
			newState.files[file.uploadId] = {
				data: file,
				meta: getDefaultNetworkStatus(),
			});

		return newState;
	})

	// REMOVE FILE
	.case(removeFile, (state: IDmcaStore, payload: IDmcaActionRemoveFilePayload) => {
		const newState = { ...state };

		delete newState.files[payload.file.uploadId];

		return newState;
	})

	// SUBMIT
	.case(submitDmca.async.started, (state: IDmcaStore) => {
		return {
			...state,
			form: {
				meta: getNetworkStatusStarted(),
			},
		};
	})
	.case(submitDmca.async.done, (state: IDmcaStore) => {
		return {
			...state,
			form: {
				meta: getNetworkStatusDone(),
			},
		};
	})
	.case(submitDmca.async.failed, (state: IDmcaStore, payload: Failure<IDmcaActionSubmitPayload, IDmcaActionSubmitErrorPayload>) => {
		return {
			...state,
			form: {
				meta: getNetworkStatusFailed(payload.error),
			},
		};
	});
